import { get, post, put } from '../../../helpers/api'
import { api } from '../api'
import {
  SET_EVOUCHER_ACTIVATION_DATA,
  SET_EVOUCHER_DATA,
  SET_EVOUCHER_LIST_DATA,
  SHOW_NOTIFICATION,
} from '../../../store/types'
import Vue from 'vue'

export const getEvoucherListAction = async ({ commit, dispatch }, query) => {
  return new Promise(resolve => {
    post(api.evoucherListing, query).then(response => {
      const json = response.data
      commit(SET_EVOUCHER_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const getEvoucherByIDAction = async ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    get(api.evoucherByID + query.id)
      .then(response => {
        const json = response.data
        commit(SET_EVOUCHER_DATA, {
          data: json,
        })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getEvoucherBySaleIDAction = async ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.evoucherBySaleID, query).then(response => {
      const json = response.data
      commit(SET_EVOUCHER_DATA, {
        data: json,
      })
      resolve(response.data)
    })
  })
}

export const postActivationRequestAction = async ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    // Todo remove
    if (query.request_type === 'request') {
      delete query.code
    }
    post(api.evoucherActivationRequest, query)
      .then(response => {
        const json = response.data
        if (query.request_type === 'request') {
          commit(SET_EVOUCHER_ACTIVATION_DATA, {
            data: json,
          })
        } else {
          commit(SET_EVOUCHER_DATA, {
            data: json.data[0],
          })
          commit(SHOW_NOTIFICATION, { title: 'Success', message: 'Activation Success', type: 'positive' })
        }
        resolve(response.data)
      })
      .catch(error => {
        if (query.request_type === 'request') {
          commit(SHOW_NOTIFICATION, {
            title: 'Activation Code Request Failed',
            message: Vue.prototype.$helpers.getValue(error, 'response.data.message', 'Please Try again later'),
            type: 'negative',
          })
        }
        reject(error.response)
      })
  })
}

export const putEvoucherReedem = async ({ commit, dispatch }, query) => {
  return new Promise(resolve => {
    put(api.evoucherRedeemByEvoucherID + '/' + query.id, query.data).then(response => {
      const json = response.data
      commit(SET_EVOUCHER_DATA, {
        data: json,
      })
      commit(SHOW_NOTIFICATION, { title: 'Success', message: 'Redemption Success', type: 'positive' })
      resolve(response.data)
    })
  })
}

export const downloadEvoucherReceipt = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.evoucherDownloadReceipt + '/' + query).then(response => {
      resolve(response.data)
    })
  })
}
